import { render, staticRenderFns } from "./ClassroomStreamPost.vue?vue&type=template&id=9202c5e0&scoped=true&"
import script from "./ClassroomStreamPost.vue?vue&type=script&lang=js&"
export * from "./ClassroomStreamPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9202c5e0",
  null
  
)

export default component.exports